import { SessionContextProps } from "../../../../Context/SessionContext";
import { UserContextProps } from "../../../../Context/UserContext";
import NoteTagConfigs from "../../../CustomerNotes/Types/NoteTagConfigs";
import { INoteTagConfiguration } from "../../../CustomerNotes/Types/NoteTagsConfiguration";

/** The props required to build the appointment note tags. */
export type AppointmentNoteTagsProps = Pick<
  SessionContextProps,
  "appointment" | "customer" | "ignoreNonCan" | "lead" | "leadDisqualifiers" | "medicalConclusions"
> &
  Pick<UserContextProps, "user">;

/** The note tag configuration for building the appointment note. */
const AppointmentNoteTagsConfig: INoteTagConfiguration<AppointmentNoteTagsProps>[] = [
  NoteTagConfigs.noLabelAppointmentServiceSubCategory,
  NoteTagConfigs.noLabelPatientAmbassadorInitials,
  NoteTagConfigs.noLabelLeadContactType,
  NoteTagConfigs.noLabelServiceType,
  NoteTagConfigs.interests,
  NoteTagConfigs.customerHeightWeightBmi,
  NoteTagConfigs.customerDateOfBirth,
  NoteTagConfigs.centerAndDistance,
  NoteTagConfigs.ignorableNonCanStatus,
  NoteTagConfigs.customerDiabetic,
  NoteTagConfigs.customerRadiationArea,
  NoteTagConfigs.defibrillatorEvalRequired
];

export default AppointmentNoteTagsConfig;
